import { makeFilterDocumentSchema, makeStringConditionSchema, matchesStringOp, } from "./filterDocumentPrimitives.js";
// ---------------------------------------------------------------------------
// Field vocabulary (v1)
// ---------------------------------------------------------------------------
export const MEMO_FILTER_STRING_FIELDS = [
    "memo.creator_name",
    "memo.transcription_status",
    "memo.summary_status",
    "memo.project_id",
    "memo.business_id",
    "memo.person_id",
];
// ---------------------------------------------------------------------------
// Conditions + the document
// ---------------------------------------------------------------------------
/** "Nothing checked" is NO condition — an `in` with zero values is rejected. */
export const memoFilterConditionSchema = makeStringConditionSchema(MEMO_FILTER_STRING_FIELDS);
export const memoFilterDocumentSchema = makeFilterDocumentSchema(memoFilterConditionSchema);
/** The empty document — "no filters active" (what Clear resets to). */
export const EMPTY_MEMO_FILTER_DOCUMENT = {
    version: 1,
    match: "all",
    conditions: [],
};
/* An exhaustive switch with NO default: a new field is a TS2366 until handled. */
function stringValue(row, field) {
    switch (field) {
        case "memo.creator_name":
            return row.creator_name ?? "";
        case "memo.transcription_status":
            return row.transcription_status ?? "";
        case "memo.summary_status":
            return row.summary_status ?? "";
        case "memo.project_id":
            return row.project_id ?? "";
        case "memo.business_id":
            return row.business_id ?? "";
        case "memo.person_id":
            return row.person_id ?? "";
    }
}
function matchesCondition(row, c) {
    return matchesStringOp(c.op, stringValue(row, c.field), c.values, c.include_empty);
}
/**
 * Apply a filter document to memo rows (AND of all conditions — v1 `match`
 * is 'all' only). An empty document returns the input array unchanged
 * (identity — callers can rely on reference equality to skip re-renders).
 */
export function applyMemoFilters(rows, doc) {
    if (doc.conditions.length === 0)
        return rows;
    return rows.filter((row) => doc.conditions.every((c) => matchesCondition(row, c)));
}
/** Count of active conditions — the filter button's badge. */
export function countActiveMemoConditions(doc) {
    return doc.conditions.length;
}
//# sourceMappingURL=memoFilters.js.map